import Tabs from '@/components/molecule/Tabs';

export default function TabsTestPage() {
  return (
    <div>
      <Tabs defaultValue="test1">
        {/* tab list */}
        <Tabs.TabsList>
          <Tabs.SingleTrigger value="test1" label="test1" />
          <Tabs.SingleTrigger value="test2" label="test2" />
          <Tabs.MultipleTrigger
            value="test3"
            label="test3"
            optionTrigger={[
              { label: 'test5-child1', value: 'test3-child1' },
              { label: 'test5-child2', value: 'test3-child2' },
              { label: 'test5-child3', value: 'test3-child3' },
            ]}
          />
          <Tabs.SingleTrigger value="test4" label="test4" />
          <Tabs.MultipleTrigger
            value="test5"
            label="test5"
            optionTrigger={[
              { label: 'test5-child1', value: 'test5-child1' },
              { label: 'test5-child2', value: 'test5-child2' },
              { label: 'test5-child3', value: 'test5-child3' },
            ]}
          />
        </Tabs.TabsList>

        {/* tab contents */}
        <Tabs.SingleContent value="test1">test1</Tabs.SingleContent>
        <Tabs.SingleContent value="test2">test2</Tabs.SingleContent>
        <Tabs.SingleContent value="test4">test4</Tabs.SingleContent>
        <Tabs.MultipleContent value="test3">
          <Tabs.MultipleContentChild value="test3-child1">
            test3-child1
          </Tabs.MultipleContentChild>
          <Tabs.MultipleContentChild value="test3-child2">
            test3-child2
          </Tabs.MultipleContentChild>
          <Tabs.MultipleContentChild value="test3-child3">
            test3-child3
          </Tabs.MultipleContentChild>
        </Tabs.MultipleContent>
        <Tabs.MultipleContent value="test5">
          <Tabs.MultipleContentChild value="test5-child1">
            test5-child1
          </Tabs.MultipleContentChild>
          <Tabs.MultipleContentChild value="test5-child2">
            test5-child2
          </Tabs.MultipleContentChild>
          <Tabs.MultipleContentChild value="test5-child3">
            test5-child3
          </Tabs.MultipleContentChild>
        </Tabs.MultipleContent>
      </Tabs>
    </div>
  );
}
